import styled from 'styled-components'
import { HiArrowNarrowDown } from 'react-icons/hi'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { device } from '../breakpoints'
import { scrollIntoView } from '@ta-interaktiv/utils'

export const StoryMenu = ({
  elementsRefs,
  elements,
  hideNumbers,
}: {
  elementsRefs: any
  elements: { html: string }[]
  hideNumbers?: boolean
}) => {
  return (
    <Container>
      <TextWidth>
        <Content>
          <Elements>
            {elements.map((element, index) => (
              <Element
                onClick={() => {
                  scrollIntoView(elementsRefs[index])
                }}
                key={index}
              >
                <div>
                  {' '}
                  <Text
                    className={hideNumbers ? 'hideNumbers' : ''}
                    dangerouslySetInnerHTML={{ __html: element.html }}
                  />
                </div>

                <Icon>
                  <HiArrowNarrowDown />
                </Icon>
              </Element>
            ))}
          </Elements>
        </Content>
      </TextWidth>
    </Container>
  )
}

const Container = styled.div`
  font-family: var(--font-sans-serif);
  counter-reset: section;
  // background: ${({ theme }) => theme.grayLight};
  padding: 1em 0;
  margin-bottom: 20px;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 1em;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 1.1em;
  }
`

const Content = styled.div`
  background: var(--menu-background);
  padding: 5px 20px 0px;
`

const Title = styled.div`
  font-family: var(--font-sans-serif);
  font-weight: 700;
  margin-bottom: 1em;
`

const Icon = styled.div`
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--icon-color);
  transition: transform 0.3s ease;
`

const Text = styled.div`
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 1.3;
  display: grid;
  grid-template-columns: min-content 1fr;

  &:before {
    font-weight: 700;
    margin-right: 1em;
    content: counter(section);
    color: var(--num-color);
    background-color: var(--num-background);
    width: 30px;
    height: 30px;
    margin-top: -2px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  &.hideNumbers {
    grid-template-columns: 1fr;
  }

  &.hideNumbers:before {
    display: none;
  }
`

const Element = styled.div`
  cursor: pointer;
  padding: 1em 0 0.6em;
  border-bottom: 1px solid var(--beige-bright-1);
  counter-increment: section;
  display: flex;
  justify-content: space-between;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    opacity: 0.85;

    ${Text} {
      font-weight: 700;
    }

    ${Icon} {
      transform: translateY(6px);
    }
  }
`

const Elements = styled.div``

export default StoryMenu
